export var JQL_EDITOR_MAIN_ID = 'jql-editor-main';
export var JQL_EDITOR_AUTOCOMPLETE_ID = 'jql-editor-autocomplete';
export var JQL_EDITOR_INPUT_ID = 'jql-editor-input';
export var JQL_EDITOR_HELP_CONTENT_ID = 'jql-editor-help-content';
export var JQL_EDITOR_VALIDATION_ID = 'jql-editor-validation';
export var SYNTAX_HELP_DESCRIPTION_ID = 'syntax-help-description';